import React, {useState} from 'react';
import Popup from '../common/CommonPopup';

const BaseImageMenu = ({ iconSvg, title, data, convertFunc }) => {

  const [showPopup, setShowPopup] = useState(false);
  const [viewImageUrl, setViewImageUrl] = useState('');

  const formatDateTime = (isoString) => {
    if (!isoString) return '';

  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 0부터 시작
  const day = String(date.getDate()).padStart(2, '0');

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const handleNewType = (type,idx, url) => {
    convertFunc(idx);
    if (type === "link"){
      window.open(url, '_blank');
    }else{
      setShowPopup(true);
      setViewImageUrl(url);
    }
    data.map(el =>{
      if(el.idx === idx){
        el.isNew = "N";
      }
    });
    
  };

  return (
    <>
    <div className="base-list-section">
        <h3 className="section-title">
            {iconSvg}
            {title}
        </h3>
        <div className="base-list-box">
            {data?.map((item, index) => (
              <div key={index} className={`base-list-item ${item.isNew == "Y" ? 'new-item' : ''}`}>
                <div>
                    <div className="base-list-header">
                        <a href={item.url}>바이럴 작업 {data.length - index}</a>
                    </div>
                    <div className="base-list-meta">업데이트 : {formatDateTime(item.regDate)}</div>
                </div>
                <div className="base-list-actions">
                    <div className="base-action-link" onClick={() => {handleNewType("link", item.idx, item.url)}}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="14" width="15.75" viewBox="0 0 576 512" fill="#22c55e"><path d="M419.5 96c-16.6 0-32.7 4.5-46.8 12.7-15.8-16-34.2-29.4-54.5-39.5 28.2-24 64.1-37.2 101.3-37.2 86.4 0 156.5 70 156.5 156.5 0 41.5-16.5 81.3-45.8 110.6l-71.1 71.1c-29.3 29.3-69.1 45.8-110.6 45.8-86.4 0-156.5-70-156.5-156.5 0-1.5 0-3 .1-4.5 .5-17.7 15.2-31.6 32.9-31.1s31.6 15.2 31.1 32.9c0 .9 0 1.8 0 2.6 0 51.1 41.4 92.5 92.5 92.5 24.5 0 48-9.7 65.4-27.1l71.1-71.1c17.3-17.3 27.1-40.9 27.1-65.4 0-51.1-41.4-92.5-92.5-92.5zM275.2 173.3c-1.9-.8-3.8-1.9-5.5-3.1-12.6-6.5-27-10.2-42.1-10.2-24.5 0-48 9.7-65.4 27.1L91.1 258.2c-17.3 17.3-27.1 40.9-27.1 65.4 0 51.1 41.4 92.5 92.5 92.5 16.5 0 32.6-4.4 46.7-12.6 15.8 16 34.2 29.4 54.6 39.5-28.2 23.9-64 37.2-101.3 37.2-86.4 0-156.5-70-156.5-156.5 0-41.5 16.5-81.3 45.8-110.6l71.1-71.1c29.3-29.3 69.1-45.8 110.6-45.8 86.6 0 156.5 70.6 156.5 156.9 0 1.3 0 2.6 0 3.9-.4 17.7-15.1 31.6-32.8 31.2s-31.6-15.1-31.2-32.8c0-.8 0-1.5 0-2.3 0-33.7-18-63.3-44.8-79.6z"/></svg>
                        링크 이동
                    </div>
                    {item.imageUrl &&<div className="base-action-image" onClick={() => {handleNewType("video", item.idx, item.imageUrl); }}>
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <rect x="3" y="4" width="18" height="16" rx="3" stroke="currentColor" stroke-width="1.8"></rect>
                            <path d="M7 15l3-3 3 3 4-4 3 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                            <circle cx="9" cy="9" r="1.8" fill="currentColor"></circle>
                        </svg>
                        이미지 보기
                    </div>}
                </div>
              </div>
            )) || []}
        </div>

    </div>
    <Popup show={showPopup} onClose={() => setShowPopup(false)} type="image" url={viewImageUrl}/>
    </>
    
  );
};

export default BaseImageMenu;